import * as React from "react"
import {twMerge} from "libs/twmerge"

/**
 * @typedef {object} OutlineButtonProps
 * @property {string} children
 */

/**
 * @type {React.FC<OutlineButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>}
 */
const OutlineButton = ({className, children, ...restProps}) => {
  return (
    <button
      {...restProps}
      className={twMerge(
        `
        flex min-h-[40px] items-center justify-center rounded-[24px]
        border border-black px-5 py-3 text-center font-action text-[14px]
        font-semibold leading-4 text-black
        active:border-gray-silver active:text-gray-silver
        disabled:border-gray-silver disabled:text-gray-silver
      `,
        className,
      )}
    >
      {children}
    </button>
  )
}

export default OutlineButton
